export default __webpack_public_path__ + "static/media/team-bold.43f01d70.svg";